import React from 'react';

import LongTextByWidth from '@/src/components/common/Elements/LongText/LongTextByWidth';
import { isHexColorDark } from '@/src/components/project/Tags/utils';
import { cn } from '@/src/util/ui';

import { DocumentTagFilterOption } from '../TagsFilter/TagsFilterButton';

type TagPillProps = {
  tag: DocumentTagFilterOption;
  className?: string;
};

export const TagPill = ({ tag, className = '' }: TagPillProps) => {
  return (
    <div
      className={cn('tw-text-center tw-rounded-[25px] tw-px-4 tw-py-2', className)}
      style={{ background: tag.color }}
    >
      <LongTextByWidth
        id={`tag+${tag.id}`}
        value={tag.label}
        maxWidth={130}
        className={cn(isHexColorDark(tag.color) === 'dark' ? 'tw-text-white' : 'tw-text-cfo-black')}
      />
    </div>
  );
};
